import { useFormikContext } from 'formik';
import { createContext, useContext, useMemo } from 'react';
import { type LanguagePackOptionDataFragment } from '../../../api/fragments/LanguagePackOptionData';
import { useGetLanguagePackOptionsQuery } from '../../../api/queries/getLanguagePackOptions';
import { type CompanyFormValues } from './CompanyForm';

const CompanyLanguageSelectedContext = createContext<LanguagePackOptionDataFragment[]>([]);

export type CompanyLanguageSelectedProviderProps = { children: JSX.Element | React.ReactNode };

export const useCompanyLanguageSelectedContext = () => useContext(CompanyLanguageSelectedContext);

const CompanyLanguageSelectedProvider = ({ children }: CompanyLanguageSelectedProviderProps) => {
    const { values } = useFormikContext<CompanyFormValues>();

    const { data } = useGetLanguagePackOptionsQuery({
        fetchPolicy: 'cache-and-network',
    });

    const languages = useMemo(() => {
        if (!values.languages?.length || !data?.languages?.items?.length) {
            return [];
        }

        const { items } = data.languages;

        return values.languages.map(id => items.find(item => id === item.id));
    }, [data, values]);

    return (
        <CompanyLanguageSelectedContext.Provider value={languages}>{children}</CompanyLanguageSelectedContext.Provider>
    );
};

export default CompanyLanguageSelectedProvider;
